<template>
  <div class="column is-9">
    <section class="hero is-info is-bold welcome is-small">
      <div class="hero-body">
        <div class="container">
          <h1 class="title">
            Hello, <em>{{ user['.value'] }}</em>.
          </h1>
          <h2 class="subtitle">
            I hope you are having a great day!
          </h2>
        </div>
      </div>
    </section>
        <section class="info-tiles">
          <div class="tile is-ancestor has-text-centered">
            <div class="tile is-parent">
              <article class="tile is-child box">
                <p class="title">{{ gymnasts.length }}</p>
                <p class="subtitle">Gymnasts</p>
              </article>
            </div>
            <div class="tile is-parent">
              <article class="tile is-child box">
                <p class="title">{{ pdfcount['.value'] }}</p>
                <p class="subtitle">Sheets Generated</p>
              </article>
            </div>
            <div class="tile is-parent">
              <article class="tile is-child box">
                <p class="title">0</p>
                <p class="subtitle">Useless Stats</p>
              </article>
            </div>
            <div class="tile is-parent">
              <article class="tile is-child box">
                <p class="title">1</p>
                <p class="subtitle">Exceptional Dev</p>
              </article>
            </div>
          </div>
        </section>
        <div class="columns">
          <div class="column is-6">
            <div class="card events-card">
              <header class="card-header">
                <p class="card-header-title">
                  Gymnasts
                </p>
                <a href="#" class="card-header-icon" aria-label="more options">
                  <span class="icon">
                    <i class="fa fa-angle-down" aria-hidden="true"></i>
                  </span>
                </a>
              </header>
              <div class="card-table">
                <div class="content">
                  <table class="table is-fullwidth is-striped">
                    <tbody>
                      <tr v-for="gymnast in gymnastsFirstTen">
                        <td width="5%"><i class="fa fa-user"></i></td>
                        <td>{{ gymnast.name }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <footer class="card-footer">
                <router-link class="card-footer-item" to="gymnasts">View All</router-link>
              </footer>
            </div>        
          </div>
          <div class="column is-6">
            <div class="card">
              <header class="card-header">
                <p class="card-header-title">
                  Gymnasts Search
                </p>
                <a href="#" class="card-header-icon" aria-label="more options">
                  <span class="icon">
                    <i class="fa fa-angle-down" aria-hidden="true"></i>
                  </span>
                </a>
              </header>
              <div class="card-content">
                <div class="content">
                  <div class="control has-icons-left has-icons-right">
                    <input class="input is-large" disabled type="text" placeholder="Not Implemented">
                    <span class="icon is-medium is-left">
                      <i class="fa fa-search"></i>
                    </span>
                    <span class="icon is-medium is-right">
                      <i class="fa fa-check"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import {db} from '@/firebase'
import firebase from 'firebase'

export default {
  name: 'Dashboard',

  data () {
    return {
      user: [],
      gymnasts: [],
      userurl: '',
      gymnastsFirstTen: [],
      pdfcount: 0
    }
  },

  firebase: {
    pdfcount: {
      source: db.ref('pdfcount'),
      asObject: true
    },
    gymnastsFirstTen: db.ref('gymnasts').limitToFirst(10),
    user: {
      source: db.ref('users/5dzZxTYBiTRIGHtcrrZKd2LsdTp1/firstname'),
      // why do I have to hardcode this string??? should I pass user id from high up before component is loaded?
      asObject: true
    },
    gymnasts: {
      source: db.ref('gymnasts')
    }
  },

  methods: {
  },

  mounted () {
    this.userurl = 'users/' + firebase.auth().currentUser.uid + '/firstname'
  }
}
</script>

<style scoped>
.welcome {
  margin-bottom: 1em;
}
</style>


// WEBPACK FOOTER //
// src/views/Dashboard.vue